import { api } from "@/lib/api";

// Helper: build a params object that includes tenant_id when provided.
// Super_admins must forward tenant_id; for normal users this is null and the
// backend falls back to user.tenant_id automatically.
const withTenant = (params, tenantId) =>
  tenantId ? { ...(params || {}), tenant_id: tenantId } : params;

export const TermsAPI = {
  list: (academic_year_id, tenantId) =>
    api.get("/terms", { params: withTenant({ academic_year_id }, tenantId) }).then((r) => r.data),
  create: (body, tenantId) =>
    api.post("/terms", body, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
  remove: (id, tenantId) =>
    api.delete(`/terms/${id}`, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
};

export const GradingScalesAPI = {
  list: (institution_id, tenantId) =>
    api.get("/grading-scales", { params: withTenant({ institution_id }, tenantId) }).then((r) => r.data),
  create: (body, tenantId) =>
    api.post("/grading-scales", body, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
  remove: (id, tenantId) =>
    api.delete(`/grading-scales/${id}`, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
};

export const PeriodsAPI = {
  list: (institution_id, tenantId) =>
    api.get("/periods", { params: withTenant({ institution_id }, tenantId) }).then((r) => r.data),
  create: (body, tenantId) =>
    api.post("/periods", body, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
  remove: (id, tenantId) =>
    api.delete(`/periods/${id}`, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
};

export const HolidaysAPI = {
  list: (institution_id, tenantId) =>
    api.get("/holidays", { params: withTenant({ institution_id }, tenantId) }).then((r) => r.data),
  create: (body, tenantId) =>
    api.post("/holidays", body, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
  remove: (id, tenantId) =>
    api.delete(`/holidays/${id}`, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
};
